export { PrettyJsonModule } from "./src/prettyjson.module";
export { SafeJsonPipe } from "./src/json.pipe";
export { PrettyJsonPipe } from "./src/prettyjson.pipe";
export { PrettyJsonComponent } from "./src/prettyjson.component";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-prettyjson/index.js
// module id = 237
// module chunks = 10